
import type { PropOptions } from 'vue';
import Vue from 'vue';

const MAX_AUTHOR_POSITION_LENGTH = 60;

export default Vue.extend({
  name: 'PublicPortfolioTestimonial',
  props: {
    authorName: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorPosition: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorAvatar: {
      type: String,
      default: '',
    } as PropOptions<string>,
    testimonialText: {
      type: String,
      required: true,
    } as PropOptions<string>,
    isPlaceholder: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  data() {
    return {
      imageError: false,
    };
  },
  computed: {
    rootClass(): Record<string, boolean> {
      return {
        'public-portfolio-testimonial': true,
        'swiper-slide': !this.isPlaceholder,
        'public-portfolio-testimonial--placeholder': this.isPlaceholder,
      };
    },
    avatarClass(): Record<string, boolean> {
      return {
        'public-portfolio-testimonial__author-avatar': true,
        'public-portfolio-testimonial__author-avatar--placeholder': !this.authorAvatar || this.imageError,
      };
    },
    authorInitials(): string {
      const [firstName, lastName] = this.authorName.split(' ');

      return firstName && lastName ? `${firstName[0]}${lastName[0]}` : firstName ? firstName.substring(0, 2) : '';
    },
    truncatedPosition(): string {
      if (!this.authorPosition) return '';
      return this.authorPosition.length >= MAX_AUTHOR_POSITION_LENGTH
        ? `${this.authorPosition.substring(0, MAX_AUTHOR_POSITION_LENGTH - 3)}...`
        : this.authorPosition;
    },
  },
});
